<script setup lang="ts">
import type { TabKey } from '@/components/base/BaseTab.vue'
import ReviewsTab from './ReviewPlatformsPage/tabs/ReviewsTab.vue'
import ConfigurationTab from './ReviewPlatformsPage/tabs/ConfigurationTab.vue'

type TabValue = 'reviews' | 'configuration'
const TAB_REVIEWS: TabValue = 'reviews'
const TAB_CONFIGURATION: TabValue = 'configuration'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const currentTab = ref<TabValue>(route.query.activeTab === TAB_CONFIGURATION ? TAB_CONFIGURATION : TAB_REVIEWS)

watch(currentTab, (value) => {
  router.replace({ query: { ...route.query, activeTab: value } })
})

const tabs: TabKey[] = [
  { value: 'reviews', name: t('pages.reviewPlatforms.tabs.reviews') },
  { value: 'configuration', name: t('pages.reviewPlatforms.tabs.configuration') }
]

function goToConfig() {
  currentTab.value = TAB_CONFIGURATION
}
</script>

<template>
  <div>
    <TheListHeader :title="t('pages.reviewPlatforms.title')" />

    <div class="px-6 pb-6 sm:px-12 sm:pb-12">
      <BaseTab v-model="currentTab" :tabs="tabs" class="mb-4" />
      <ReviewsTab v-if="currentTab === 'reviews'" @go-to-config="goToConfig" />
      <ConfigurationTab v-else />
    </div>
  </div>
</template>
